import React, { useMemo, useState } from 'react';
import { useAnalytics } from 'react-shisell';
import { otherDisplayText, ratingToGoodTag, TagData, TagOptionsMap } from './components/TagOptionsMap';
import { isTagSelected } from './components/TagWrapper';
import { FiveStarSurveyComponent } from './FiveStarSurveyComponent';

export type FiveStarSurveyProps = {
  guideName: string;
};

export const FiveStarSurvey = ({ guideName }: FiveStarSurveyProps) => {
  const [starRating, setStarRating] = useState(0);
  const [tagSelection, setTagSelection] = useState<TagData[]>([]);
  const [otherTag, setOtherTag] = useState<TagData>();
  const [lastSelectedTag, setLastSelectedTag] = useState<TagData>();
  const analytics = useAnalytics();

  const starClick = (rating: number) => {
    if (starRating === rating) {
      if (rating === 1) {
        rating = 0;
      } else {
        return;
      }
    }

    setStarRating(rating);

    const canResetTagList = (starRating > 0 && starRating <= 4 && rating > 4) || (rating < 5 && starRating > 4);
    
    if (canResetTagList) {
      setTagSelection([]);
      setOtherTag(undefined);
      setLastSelectedTag(undefined);
    }

  };

  const onTagClick = (selectedTag: TagData) => {
    analytics.dispatcher
      .withExtra('tag', selectedTag.displayText)
      .withExtra('rating', starRating)
      .withExtra('guideName', guideName)
      .withExtra('TagClicked', 'TagClicked')
      .withExtra('isTagSelected', !isTagSelected(selectedTag, tagSelection))
      .dispatch('SH_WEB_EVENT');

    const exists = tagSelection.find((t) => t.displayText === selectedTag.displayText);
    let tags: TagData[];

    if (exists) {
      tags = tagSelection.filter((t) => t.displayText !== selectedTag.displayText);
      setTagSelection(tags);
      // By default wipe out the selected tag
      setLastSelectedTag(undefined);
    } else {
      tags = [...tagSelection, selectedTag];
      setTagSelection(tags);
      setLastSelectedTag(selectedTag);
    }
    setOtherTag(tags.find((tag) => tag.displayText === otherDisplayText));
  };

  const onCommentSend = (commentText: string, currentTag: TagData) => {
    analytics.dispatcher
      .withExtra('tag', currentTag.displayText)
      .withExtra('surveyFeedback', commentText)
      .withExtra('isGoodFeedback', currentTag.isGoodTag)
      .withExtra('rating', starRating)
      .withExtra('ActionId', 'Survey_Submit_Clicked')
      .dispatch('SH_WEB_EVENT');
    setOtherTag(undefined);
  };

  const tags = useMemo(
    (): TagData[] =>
      Object.entries(TagOptionsMap)
        .map(([key, data]) => ({ key, ...data }))
        .filter((tag) => tag.isGoodTag === ratingToGoodTag[starRating]),
    [starRating]
  );

  return (
    <FiveStarSurveyComponent
      lastSelectedTag={lastSelectedTag}
      starRating={starRating}
      tags={tags}
      tagSelection={tagSelection}
      onTagClick={onTagClick}
      onCommentSend={onCommentSend}
      starClick={starClick}
      otherTag={otherTag}
    />
  );
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/FiveStarSurvey/FiveStarSurvey.tsx